export default __webpack_public_path__ + "static/media/dumble-squats.4c162705.webp";